import { CloseIcon } from '../icons'

const STEPS = [
  {
    title: 'Review & Edit',
    text: 'Check your menu preview on the left. Make any text changes, adjust prices, reorder items, or organize sections using the editing tools on the right.',
  },
  {
    title: 'Customize Style',
    text: 'Click "Edit styles" to adjust text colors and column layout to match your restaurant\'s brand.',
  },
  {
    title: 'Get Menu Code',
    text: 'Click "Get menu code" to generate HTML embed code. Copy it and paste directly into your website for a responsive, accessible menu.',
  },
]

export const InfoModal = ({ onClose }: { onClose: () => void }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-lg p-6 max-w-2xl w-full">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-custom-dark">How Text to Table Works</h2>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600" aria-label="Close">
          <CloseIcon />
        </button>
      </div>
      <div className="space-y-4 text-gray-700">
        <p className="font-medium">Your menu has been uploaded! Now refine and export it in 3 simple steps:</p>

        <div className="space-y-3">
          {STEPS.map((step, index) => (
            <div key={step.title} className="flex items-start space-x-3">
              <div className="w-8 h-8 border-2 border-brand-primary rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-brand-primary font-medium">{index + 1}</span>
              </div>
              <div>
                <p className="font-medium">{step.title}</p>
                <p className="text-sm text-gray-600">{step.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 pt-4 border-t border-gray-200 space-y-2">
          <p className="text-sm text-gray-600">
            <strong>Tip:</strong> Use the preview panel on the left to see real-time updates as you make changes.
          </p>
          <p className="text-sm text-gray-600">
            <strong>Need help?</strong> Contact our support team at{' '}
            <a href="mailto:team@studioqdesigns.ca" className="text-brand-primary underline">
              team@studioqdesigns.ca
            </a>
            .
          </p>
        </div>
      </div>
      <div className="flex justify-end mt-6">
        <button
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-white rounded-md hover:opacity-80 bg-brand-primary"
        >
          Got it!
        </button>
      </div>
    </div>
  </div>
)
